var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parking-space-page"},[(!_vm.enableParkingSpace)?_c('div',{staticClass:"empty-page"},[_c('i',{staticClass:"el-icon-data-analysis empty-icon"}),_c('div',{staticClass:"empty-title"},[_vm._v("暂无数据")]),_c('div',{staticClass:"empty-desc"},[_vm._v("车位可视化数据暂未接入")])]):_c('div',{ref:"carContainer",staticClass:"car-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }